const API_URL = process.env.REACT_APP_BACKEND_URL || '';

interface RequestOptions extends RequestInit {
  skipAuth?: boolean;
}

export async function apiClient(endpoint: string, options: RequestOptions = {}) {
  const { skipAuth, ...fetchOptions } = options;
  
  const config: RequestInit = {
    ...fetchOptions,
    credentials: 'include' as RequestCredentials,
    headers: {
      'Content-Type': 'application/json',
      ...fetchOptions.headers,
    },
  };

  const response = await fetch(`${API_URL}${endpoint}`, config);
  return response;
}

export async function apiJson<T = any>(endpoint: string, options: RequestOptions = {}): Promise<T> {
  const response = await apiClient(endpoint, options);
  if (!response.ok) {
    let error: { detail?: unknown } = {};
    try {
      error = await response.json();
    } catch {
      error = {};
    }
    let message: string;
    const detail = error.detail;
    if (typeof detail === "string" && detail.trim()) {
      message = detail;
    } else if (Array.isArray(detail) && detail.length > 0) {
      message = detail
        .map((e: { loc?: string[]; msg?: string; type?: string }) => {
          const field = (e.loc || []).filter((p) => p !== "body").join(".");
          if (e.type === "value_error" && /email/i.test(field)) return "Email invalide";
          if (e.type === "missing") return `Champ requis manquant : ${field}`;
          if (/email/i.test(field) && /value/i.test(e.type || "")) return "Email invalide";
          return `${field}: ${e.msg || e.type || "erreur"}`;
        })
        .join(" · ");
    } else if (detail && typeof detail === "object") {
      message = JSON.stringify(detail);
    } else {
      // Body stripped by proxy or empty — fallback to friendly HTTP-based message
      if (response.status === 422) message = "Données invalides — vérifiez l'email et le mot de passe (8 caractères minimum, email valide).";
      else if (response.status === 401) message = "Identifiants incorrects.";
      else if (response.status === 403) message = "Accès refusé.";
      else if (response.status === 404) message = "Ressource introuvable.";
      else if (response.status === 409) message = "Cet email est déjà utilisé.";
      else if (response.status === 429) message = "Trop de tentatives — réessayez dans quelques instants.";
      else if (response.status >= 500) message = "Le serveur a rencontré une erreur. Réessayez dans un instant ou contactez le support.";
      else message = response.statusText || `Erreur HTTP ${response.status}`;
    }
    const err = new Error(message);
    (err as Error & { status?: number }).status = response.status;
    throw err;
  }
  return response.json();
}
